import * as Sentry from "@sentry/react";

import { config } from "@shared/config";
import { getCurrentVersion } from "@shared/features/app/hooks/use-current-version";

export const initTracking = async () => {
  if (config.VITE_SENTRY_DSN) {
    const release = `${config.VITE_MC_APP_NAME}@${await getCurrentVersion()}`;

    console.debug("[Sentry] Initializing...", {
      release,
      environment: config.mode,
    });

    Sentry.init({
      release,
      dsn: config.VITE_SENTRY_DSN,
      sendDefaultPii: true,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Enable logs to be sent to Sentry
      enableLogs: true,
      tracesSampleRate: 0.8,
      tracePropagationTargets: [
        /localhost:3000/i,
        /api\.mobilitycare\.fr/i,
        /dev\.api\.mobilitycare.fr/i,
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      environment: config.mode,
    });
  }
};

export { Sentry };
